module.exports = __webpack_public_path__ + "static/parfume_4k-033d79f494747f41c62967959a50d240.webp";